module.exports = __webpack_public_path__ + "prod/1.42.2/img/yutong-icon.81c607c4.png";